import type { ApiError } from '@common/api/graphql/apolloClient';
import { requestGifteeBoxIssueAmount } from '@common/api/graphql/requestGifteeBoxIssueAmountGql';
import { createSuccessMessage } from '@common/api/graphql/successMessage';
import {
  requestGifteeBoxIssueAmountFailure,
  requestGifteeBoxIssueAmountStart,
  requestGifteeBoxIssueAmountSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

export const requestGifteeBoxIssueAmountSuccessThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    const snackbarMessage = createSuccessMessage('数量確定');
    dispatch(requestGifteeBoxIssueAmountSuccess(snackbarMessage));
    return Promise.resolve();
  };

export const requestGifteeBoxIssueAmountFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(requestGifteeBoxIssueAmountFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const requestGifteeBoxIssueAmountThunk =
  (
    issueAmount: number,
    bulkGifteeBoxIssueConfigUrlCode: UrlCode
  ): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(requestGifteeBoxIssueAmountStart());

    return requestGifteeBoxIssueAmount(
      issueAmount,
      bulkGifteeBoxIssueConfigUrlCode
    )
      .then(() => dispatch(requestGifteeBoxIssueAmountSuccessThunk()))
      .catch(error => dispatch(requestGifteeBoxIssueAmountFailureThunk(error)));
  };
